var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("messages-table", { attrs: { url: _vm.url, params: _vm.params } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }